import { render } from "./ShareModal.vue?vue&type=template&id=00489504&scoped=true&ts=true"
import script from "./ShareModal.vue?vue&type=script&lang=ts"
export * from "./ShareModal.vue?vue&type=script&lang=ts"

import "./ShareModal.vue?vue&type=style&index=0&id=00489504&lang=scss&scoped=true"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00489504"]])

export default __exports__